// extracted by mini-css-extract-plugin
module.exports = {"optionTextContainer":"OrderByNewPopular__optionTextContainer","valueTextContainer":"OrderByNewPopular__valueTextContainer"};